import { Badge, Button, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@careflux/primitives';
import { Eye } from 'lucide-react';
import type { ComparisonsTableProps } from './components.types';
import { EMPTY_VALUE, MAGNITUDE_LABELS, formatDay } from './formatting';
import { MAGNITUDE_BADGE_VARIANT, similarityLevel, similarityVariants } from './summaryQuality.styles';

export const ComparisonsTable = ({ items, onView }: ComparisonsTableProps) => (
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead>Dagsetning</TableHead>
        <TableHead>Líkindi</TableHead>
        <TableHead>Breytingar</TableHead>
        <TableHead className="text-right">Aðgerðir</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {items.map((item) => (
        <TableRow key={item.audioId}>
          <TableCell className="text-muted-foreground">{formatDay(item.createdAt)}</TableCell>
          <TableCell>
            {item.metrics ? (
              <span className={similarityVariants({ level: similarityLevel(item.metrics.similarityPercentage) })}>
                {`${item.metrics.similarityPercentage}%`}
              </span>
            ) : (
              EMPTY_VALUE
            )}
          </TableCell>
          <TableCell>
            {item.metrics ? (
              <Badge variant={MAGNITUDE_BADGE_VARIANT[item.metrics.changeMagnitude]}>
                {MAGNITUDE_LABELS[item.metrics.changeMagnitude]}
              </Badge>
            ) : (
              EMPTY_VALUE
            )}
          </TableCell>
          <TableCell className="text-right">
            <Button variant="ghost" size="sm" onClick={() => onView(item.audioId)}>
              <Eye />
              Skoða
            </Button>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
